module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "board-description"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('content', {
    staticClass: "media-content"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v(" " + _vm._s(_vm.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "top-posts-section"
  }, _vm._l((_vm.topPosts), function(post, index) {
    return (!index || _vm.showAllTopPosts) ? _c('div', {
      key: post.id,
      staticClass: "top-post"
    }, [_c('span', {
      staticClass: "tag is-warning",
      class: index ? 'invisible' : 'visible'
    }, [_vm._v("置顶")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "target": "_blank",
        "to": _vm.getArticle(post.gid)
      }
    }, [_c('p', [_c('strong', [_vm._v(" " + _vm._s(post.title))])])]), _vm._v(" "), (!index) ? _c('span', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.showAllTopPosts = _vm.showAllTopPosts ? false : true
        }
      }
    }, [_c('i', {
      staticClass: "icon iconfont",
      class: _vm.showAllTopPosts ? 'icon-less' : 'icon-moreunfold'
    })]) : _vm._e()], 1) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "posts"
  }, _vm._l((_vm.posts), function(article, index) {
    return _c('div', {
      key: index,
      staticClass: "post"
    }, [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": _vm.getArticle(article.gid)
      }
    }, [_c('div', {
      staticClass: "poster media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(" " + _vm._s(article.title))])])]), _vm._v(" "), _c('nav', {
      staticClass: "article-footer level is-mobile"
    }, [_c('div', {
      staticClass: "level-left"
    }, [_c('span', {
      staticClass: "level-item"
    }, [_vm._v(_vm._s(article.poster))]), _vm._v(" "), _c('span', {
      staticClass: "level-item"
    }, [_vm._v(" " + _vm._s(article.replyTime) + " 更新")])]), _vm._v(" "), _c('div', {
      staticClass: "level-right"
    }, [_c('span', {
      staticClass: "level-item"
    }, [_vm._v(" " + _vm._s(article.replyCount) + " 人回复")])])])])])]), _vm._v(" "), _c('hr')], 1)
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "paginate"
  }, [_c('picker', {
    ref: "pagePicker",
    attrs: {
      "data": _vm.pagePickerData
    },
    on: {
      "change": _vm.pageChanged
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "columns is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.hidePagePicker
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getFirstPage
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentPage + '/' + _vm.totalPage))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getLastPage
    }
  }, [_vm._v("末页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getSelectedPage
    }
  }, [_vm._v("确认")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "columns is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getPrevPage
    }
  }, [_vm._v("上一页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.showPagePicker
    }
  }, [_vm._v(_vm._s(_vm.currentPage + '/' + _vm.totalPage))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getNextPage
    }
  }, [_vm._v("下一页")])])])])], 1), _vm._v(" "), _c('float-button', {
    nativeOn: {
      "click": function($event) {
        _vm.newPost()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aea14a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Board.vue
// module id = 234
// module chunks = 1